/**
 * The layered dark stage: a drifting aurora as the key light, a top spotlight,
 * a fine dot-field for depth, film grain and an edge vignette. All CSS, all
 * decorative (hidden from assistive tech), aurora pauses under reduced-motion.
 */
export function HeroBackground(): JSX.Element {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      {/* Key light: a slow-drifting aurora up in the visual quadrant. */}
      <div
        className="absolute -right-[10%] -top-[25%] h-[70rem] w-[70rem] hero-aurora"
        data-hero-loop
      />

      {/* Stage spotlight + depth field. */}
      <div className="hero-spotlight absolute inset-0" />
      <div className="hero-dots absolute inset-0" />
      <div className="hero-grid absolute inset-0 opacity-40" />

      {/* Accent warmth low-left, so the composition isn't mono-violet. */}
      <div
        className="absolute -bottom-40 left-[6%] h-[26rem] w-[26rem] rounded-full opacity-30 blur-[110px]"
        style={{
          background: 'radial-gradient(circle, var(--hero-glow-accent) 0%, transparent 70%)',
        }}
      />

      {/* Grain + vignette. */}
      <div className="hero-noise absolute inset-0 opacity-[0.3]" />
      <div className="hero-vignette absolute inset-0" />

      {/* Seam gradient so the dark hero melts into the light page below. */}
      <div
        className="absolute inset-x-0 bottom-0 h-40"
        style={{ background: 'linear-gradient(to bottom, transparent, var(--page-bg))' }}
      />
    </div>
  );
}
